import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19f2de46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ContractForm" }
const _hoisted_2 = { class: "ContractForm__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "ContractForm__loader"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Загрузка договора...", -1))
const _hoisted_6 = {
  key: 1,
  class: "ContractForm__body"
}
const _hoisted_7 = { class: "grid gap-3" }
const _hoisted_8 = {
  key: 0,
  class: "font-semibold text-red-500"
}
const _hoisted_9 = { class: "flex items-center justify-between mt-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Добавить договор" }),
      _createVNode(_component_the_button, {
        class: "second text small",
        disabled: _ctx.state.is_loading,
        onClick: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_loader, { class: "primary mt-1" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_the_select, {
              placeholder: "Клиент",
              loading: _ctx.data_state.companies.is_loading,
              failed: _ctx.data_state.companies.is_failed,
              "error-text": "При получении списка компаний произошла ошибка",
              options: _ctx.data_state.companies.list,
              value: _ctx.state.company_id,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.company_id) = $event)),
              "is-invalid": _ctx.state_form$.company_id.$error,
              "validation-errors": _ctx.state_form$.company_id.$errors,
              "infinite-scroll": "",
              "search-without-refresh": "",
              onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
              onChange: _ctx.onCompanySelected,
              onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
              onSearch: _ctx.searchCompanies,
              onOptionBySearch: _ctx.unshiftFindedCompany
            }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onChange", "onSearch", "onOptionBySearch"]),
            _createVNode(_component_the_select, {
              placeholder: "Подразделение",
              loading: _ctx.data_state.subdivisions.is_loading,
              failed: _ctx.data_state.subdivisions.is_failed,
              "error-text": "При получении списка подразделений произошла ошибка",
              options: _ctx.data_state.subdivisions.list,
              "is-invalid": _ctx.state_form$.subdivision_id.$error,
              "validation-errors": _ctx.state_form$.subdivision_id.$errors,
              value: _ctx.state.subdivision_id,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.subdivision_id) = $event)),
              onRefresh: _ctx.loadSubdivisions,
              onChange: _ctx.onSubdivisionSelected
            }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"]),
            _createVNode(_component_the_input, {
              disabled: "",
              placeholder: "Наименование компании",
              "is-invalid": _ctx.state_form$.name.$error,
              "validation-errors": _ctx.state_form$.name.$errors,
              value: _ctx.state.name,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.name) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              disabled: "",
              placeholder: "БИН",
              "is-invalid": _ctx.state_form$.bin.$error,
              "validation-errors": _ctx.state_form$.bin.$errors,
              value: _ctx.state.bin,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.bin) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              placeholder: "Номер договора",
              "is-invalid": _ctx.state_form$.number.$error,
              "validation-errors": _ctx.state_form$.number.$errors,
              value: _ctx.state.number,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.number) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              type: "date",
              placeholder: "Дата заключения договора",
              "is-invalid": _ctx.state_form$.date.$error,
              "validation-errors": _ctx.state_form$.date.$errors,
              value: _ctx.state.date,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.date) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              type: "date",
              placeholder: "Дата окончания действия",
              "is-invalid": _ctx.state_form$.expiration_date.$error,
              "validation-errors": _ctx.state_form$.expiration_date.$errors,
              value: _ctx.state.expiration_date,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.expiration_date) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            (_ctx.contract && _ctx.contract.path)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Внимание: Если вы загрузите новый договор, старый удалится безвозвратно (файл: " + _toDisplayString(_ctx.contract.original_name) + "). ", 1))
              : _createCommentVNode("", true),
            _createVNode(_component_file_reader, {
              placeholder: "Выберите договор (pdf)",
              accept: "application/pdf",
              value: _ctx.state.files,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.files) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_the_select, {
              placeholder: "Тип договора",
              loading: _ctx.data_state.types.is_loading,
              failed: _ctx.data_state.types.is_failed,
              "error-text": "При получении списка типов произошла ошибка",
              "is-invalid": _ctx.state_form$.type_id.$error,
              "validation-errors": _ctx.state_form$.type_id.$errors,
              options: _ctx.data_state.types.list,
              value: _ctx.state.type_id,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.type_id) = $event)),
              "infinite-scroll": "",
              onRefresh: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadTypes(_ctx.data_state.types.pagination.current_page))),
              onLoadmore: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadMoreTypes(_ctx.data_state.types.pagination.current_page + 1))),
              onChange: _ctx.onTypeChange
            }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value", "onChange"]),
            _createVNode(_component_the_select, {
              "can-deselect": "",
              placeholder: "Услуги",
              loading: _ctx.data_state.services.is_loading,
              failed: _ctx.data_state.services.is_failed,
              "error-text": "При получении списка произошла ошибка",
              options: _ctx.data_state.services.list,
              value: _ctx.state.serviceIds,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.serviceIds) = $event)),
              "is-invalid": _ctx.state_form$.serviceIds.$error,
              "validation-errors": _ctx.state_form$.serviceIds.$errors,
              multiselect: "",
              onRefresh: _ctx.loadServices
            }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh"]),
            (_ctx.state.type_id === 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_the_input, {
                    placeholder: "Предмет договора",
                    "is-invalid": _ctx.state_form$.description.$error,
                    "validation-errors": _ctx.state_form$.description.$errors,
                    value: _ctx.state.description,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.description) = $event))
                  }, null, 8, ["is-invalid", "validation-errors", "value"]),
                  _createVNode(_component_the_select, {
                    placeholder: "Тип тарифа",
                    "is-invalid": _ctx.state_form$.tariff_id.$error,
                    "validation-errors": _ctx.state_form$.tariff_id.$errors,
                    options: _ctx.TARIFF_TYPES,
                    value: _ctx.state.tariff_id,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.tariff_id) = $event))
                  }, null, 8, ["is-invalid", "validation-errors", "options", "value"]),
                  _createVNode(_component_the_select, {
                    placeholder: "Порядок изменения цен",
                    "is-invalid": _ctx.state_form$.price_change_id.$error,
                    "validation-errors": _ctx.state_form$.price_change_id.$errors,
                    options: _ctx.PRICE_CHANGE_TYPES,
                    value: _ctx.state.price_change_id,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.price_change_id) = $event)),
                    onChange: _ctx.onPriceChange
                  }, null, 8, ["is-invalid", "validation-errors", "options", "value", "onChange"]),
                  _createVNode(_component_the_input, {
                    placeholder: "Сумма договора",
                    value: _ctx.state.amount,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.amount) = $event)),
                    maska: _ctx.PRICE_MASK
                  }, null, 8, ["value", "maska"]),
                  (_ctx.state.price_change_id === 3)
                    ? (_openBlock(), _createBlock(_component_the_input, {
                        key: 0,
                        placeholder: "Уведомление до",
                        value: _ctx.state.notice_before,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.notice_before) = $event)),
                        "is-invalid": _ctx.state_form$.notice_before.$error,
                        "validation-errors": _ctx.state_form$.notice_before.$errors
                      }, null, 8, ["value", "is-invalid", "validation-errors"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_checkbox, {
              label: "Пролонгация",
              value: _ctx.state.is_auto_renewal,
              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.is_auto_renewal) = $event)),
              disabled: _ctx.state.is_loading,
              "return-integer": ""
            }, null, 8, ["value", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_the_button, {
              class: "second text small",
              disabled: _ctx.state.is_loading,
              onClick: _ctx.resetForm
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_the_button, {
              class: "primary text small",
              loading: _ctx.state.is_loading,
              onClick: _ctx.addContract
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ]))
  ]))
}